import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { PUBLIC_PREFIX_PATH } from 'configs/AppConfig'
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const PublicViews = () => {
  return (
    <Suspense fallback={<Loading cover="page"/>}>
      <Switch>
        <Route path={`${PUBLIC_PREFIX_PATH}/:project/fixed/dashboard/:dashboard/:secondId?`} component={lazy(() => import(`../app-views/dashboard`))} />
        <Route path={`${PUBLIC_PREFIX_PATH}/:project/fixed/form/:form`} component={lazy(() => import(`../app-views/form`))} />
        <Redirect from={`${PUBLIC_PREFIX_PATH}/:project/*`} to={({ match }) => `${APP_PREFIX_PATH}/${match.params.project}/home`} />

       </Switch>
    </Suspense>
  )
}

export default PublicViews;
